import companyProfile from '../../widgets/general/company-profile'
import companyArticles from '../../widgets/general/company-articles'
import executivesInCompany from '../../widgets/general/executives-in-company'

const companyLayoutWidgets = () => [
  companyProfile(),
  companyArticles(),
  executivesInCompany()
]

export default companyLayoutWidgets
